"use strict";

import angular from "angular";

angular
    .module("nucont.accounting.reportingCenter")
    .config(["$stateProvider", routeConfig]);

function reportingCenterLazyLoad(transition) {
    const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
    return import(
        /* webpackChunkName: "feature-accounting-reporting-center" */ "./reporting-center.entry"
    ).then(() => $ocLazyLoad.inject("nucont.accounting.reportingCenter"));
}

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.reporting-center", {
            url: "/central-relatorios",
            lazyLoad: reportingCenterLazyLoad,
            views: {
                "admin@nucont.accounting": {
                    component: "reportingCenterViewComponent"
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel4"
                }
            },
            bodyClass: "reporting-center"
        })
        .state("nucont.accounting.reporting-center.automations", {
            url:
                "/automacoes?openCreateAutomation&openActivateAutomation&openCreateAutomationEsocial",
            views: {
                "subRouter@nucont.accounting.reporting-center": {
                    component: "reportingCenterAutomationsViewComponent"
                }
            },
            params: {
                openCreateAutomation: {
                    value: null,
                    dynamic: true
                },
                openActivateAutomation: {
                    value: null,
                    dynamic: true
                },
                openCreateAutomationEsocial: {
                    value: null,
                    dynamic: true
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel3",
                    setAttrs: [
                        {
                            object: "headerConfig",
                            path: "searchInput.placeholder",
                            value: "Pesquisar Dash"
                        }
                    ]
                }
            },
            bodyClass: "reporting-center"
        })
        .state("nucont.accounting.reporting-center.generateds", {
            url:
                "/gerados?filter&progressLevelSideNav&openConfig&event&companyId&searchText",
            params: {
                event: {
                    value: null,
                    dynamic: true
                },
                filter: { value: "", dynamic: true },
                openConfig: {
                    value: null,
                    dynamic: true
                },
                progressLevelSideNav: {
                    value: null,
                    dynamic: true
                },
                companyId: {
                    value: null,
                    dynamic: true
                },
                searchText: {
                    value: null,
                    dynamic: true
                }
            },
            views: {
                "subRouter@nucont.accounting.reporting-center": {
                    component: "reportingCenterGeneratedsViewComponent"
                }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel3",
                    setAttrs: [
                        {
                            object: "headerConfig",
                            path: "searchInput.placeholder",
                            value: "Pesquisar empresa"
                        }
                    ]
                }
            },
            bodyClass: "reporting-center"
        });
}
